/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React,{ Fragment, useContext, useEffect, useState } from "react";
import { ContentZoneContext } from "cms/components/context";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { ReactComponent as RightArrowAltIcon } from "assets/images/icons/common/right-arrow-alt.svg";


const TestimonialHighlightComponentDisplay = () => {

    const { token } = useAuth();
    const ctx = useContext(ContentZoneContext);
    const { component } = ctx || {};
    const title = component.title;
    const description = component.description;
    const image_guid = component.image;
    const company_logo = component.company_logo;
    const testimonial_quote = component.testimonial_quote;
    const person_image = component.person_image;
    const person_name = component.person_name;
    const person_title = component.person_title;
    const person_company = component.person_company;
    const link = component.link;

    const [image, setImage] = useState(null);
    useEffect(() => {
        const getImage = async () => {
            const image = await SimpliCityAdminSDK.images.findOne(token, image_guid);
            setImage(image);
        };
        getImage();
    }, [image_guid, token]);
    return (
        <Fragment>
            <div className="testimonial-highlight-display-content">
                <div className="testimonial-highlight-display-content-title">
                    {title}
                </div>
                <div className="testimonial-highlight-display-content-description">
                    {description}
                </div>
                <div className="testimonial-highlight-display-content-container">
                    <div className="testimonial-highlight-display-content-image">
                        <img className="testimonial-highlight-display-content-image-img" src={image?.url} alt={title} />
                    </div>
                    <div className="testimonial-container">
                        <div className="testimonial-icon">
                            <img src={company_logo?.url} alt={title} />
                        </div>
                        <div className="testimonial_quote">
                            <RichTextPreview richtext={testimonial_quote} />
                        </div>
                        <div className="testimonial-person-info">
                            <div className="testimonial-person-icon">
                                <img src={person_image?.url} alt={person_name} />
                            </div>
                            <div className="testimonial-person-details">
                                <div className="testimonial-person-name">
                                    {person_name}
                                </div>
                                <div className="testimonial-person-title">
                                    {person_title}
                                </div>
                                <div className="testimonial-person-company">
                                    {person_company}
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-link-container">
                            <a className="testimonial-link" href={link?.url} target="_blank" rel="noopener noreferrer">{link?.text}</a>
                            <div className="testimonial-link-icon" onClick={() => window.open(link?.url, '_blank')}>
                                <RightArrowAltIcon />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export { TestimonialHighlightComponentDisplay };
